var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 32,
    viewBox: "0 0 27 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1979 20.2327H3.70471C2.11387 20.2327 1.15979 18.4654 2.03261 17.1354L11.5526 2.62877C12.3323 1.44064 14.0676 1.42196 14.8727 2.59302L24.846 17.0996C25.7583 18.4266 24.8083 20.2327 23.1979 20.2327Z",
    fill: "#FFAE11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0239 7.878V11.882C14.0239 12.3067 14.0029 12.7243 13.9609 13.135C13.9189 13.541 13.8629 13.9727 13.7929 14.43H12.6239C12.5539 13.9727 12.4979 13.541 12.4559 13.135C12.4139 12.7243 12.3929 12.3067 12.3929 11.882V7.878H14.0239ZM12.1269 17.048C12.1269 16.9033 12.1526 16.7657 12.2039 16.635C12.2599 16.5043 12.3346 16.3923 12.4279 16.299C12.5259 16.2057 12.6403 16.131 12.7709 16.075C12.9016 16.019 13.0416 15.991 13.1909 15.991C13.3356 15.991 13.4733 16.019 13.6039 16.075C13.7346 16.131 13.8466 16.2057 13.9399 16.299C14.0333 16.3923 14.1079 16.5043 14.1639 16.635C14.2199 16.7657 14.2479 16.9033 14.2479 17.048C14.2479 17.1973 14.2199 17.3373 14.1639 17.468C14.1079 17.594 14.0333 17.7037 13.9399 17.797C13.8466 17.8903 13.7346 17.9627 13.6039 18.014C13.4733 18.07 13.3356 18.098 13.1909 18.098C13.0416 18.098 12.9016 18.07 12.7709 18.014C12.6403 17.9627 12.5259 17.8903 12.4279 17.797C12.3346 17.7037 12.2599 17.594 12.2039 17.468C12.1526 17.3373 12.1269 17.1973 12.1269 17.048Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.7b1851a92231b28bb46a3a7d6fb17890.svg";
export { ForwardRef as ReactComponent };